"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=InvalidTeacher.js.map